import React from "react";
import { Grid } from "@mui/material";
import { useSectionConfig } from "../context/SectionConfigContext";

function ConfigurableField({
  sectionId,
  fieldName,
  xs = 12,
  sm,
  md,
  children,
}) {
  const { isFieldActive, isFieldMandatory, config } = useSectionConfig();

  if (config && !isFieldActive(sectionId, fieldName)) return null;

  const required = isFieldMandatory(sectionId, fieldName);

  return (
    <Grid item xs={xs} sm={sm} md={md}>
      {typeof children === "function" ? children({ required }) : children}
    </Grid>
  );
}

export default ConfigurableField;
